(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moorland-media-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-moorland-media-story]').forEach((section) => {
        if (section.dataset.motionReady === 'true') return;
        section.dataset.motionReady = 'true';
        if (section.dataset.animate !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;
        section.classList.add('has-motion');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        section.querySelectorAll('[data-media-reveal]').forEach((element) => observer.observe(element));
      });
    };
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moorland-v4-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => root.querySelectorAll('[data-mv4-hero]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      if (section.dataset.animate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      section.classList.add('has-motion');
      requestAnimationFrame(() => section.querySelectorAll('[data-mv4-reveal]').forEach((element) => element.classList.add('is-visible')));
    });
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moorland-v4-journal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => root.querySelectorAll('[data-mv4-journal]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      if (section.dataset.animate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      section.classList.add('has-motion');
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (!entry.isIntersecting) return; entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }), { threshold: .14 });
      section.querySelectorAll('[data-mv4-journal-reveal]').forEach((element) => observer.observe(element));
    });
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moorland-walk-system"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const enhance = (section) => {
      if (section.dataset.enhanced === 'true') return;
      const tabs = Array.from(section.querySelectorAll('[data-system-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-system-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const activate = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
      };

      section.dataset.enhanced = 'true';
      activate(0);

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          const update = () => activate(index);
          if (!reducedMotion && document.startViewTransition) document.startViewTransition(update);
          else update();
        });
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          tabs[nextIndex].focus();
          activate(nextIndex);
        });
      });

      if (section.dataset.animate === 'true' && !reducedMotion && 'IntersectionObserver' in window) {
        section.classList.add('has-motion');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.16 });
        section.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
      }
    };

    const init = (root = document) => root.querySelectorAll('[data-moorland-system]').forEach(enhance);
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
